import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Trash2 } from "react-feather";
import Select from "react-select";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {
  API_BASE_URL,
  //   GET_USER_STORES,
  GET_CUSTOMERS,
  GET_PAYMENTS_TYPES,
  GET_TAXES_DATA,
  IMAGE_URL_IBIZ,
  INSERT_ORDERS,
  GET_POS_TERMINALS,
  GET_STORE,
  //   GET_USERS,
  GET_STAFF,
  GET_ORDERS,
} from "../../Config";
import Axios from "axios";
// import Table from "../../core/pagination/datatable";
import { Table } from "antd";
import AddCustomerModal from "./Addcustomermodal";
import { useReactToPrint } from "react-to-print";
import SpinLoader from "../loader/SpinLoader";
import AdjustDiscount from "./AdjustDiscount";

const AddSaleNew = () => {
  const [searchParams] = useSearchParams();

  const isGstExempt =
    searchParams.get("gst") === "0" || searchParams.get("mode") === "exempt";
  const [userDataSession, setUserDataSession] = useState({});
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  const [selectedStoreName, setSelectedStoreName] = useState("");
  const [unitProducts, setUnitProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedCusId, setSelectedCusId] = useState(null);
  const [customersDDL, setCustomersDDL] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);
  const [payments, setPayments] = useState([]);
  const [currentPaymentAmount, setCurrentPaymentAmount] = useState("");
  const [taxesData, setTaxesData] = useState([]);
  const [discounts, setDiscounts] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [customDiscountAmount, setCustomDiscountAmount] = useState("");
  const [defaultTax, setDefaultTax] = useState(null);
  const [usersList, setUsersList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  //   const [isGstExempt, setIsGstExempt] = useState(false);
  const [storeAddress, setStoreAddress] = useState("");
  const [orgGST, setOrgGST] = useState("");

  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  // const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  // const [invoiceHtml, setInvoiceHtml] = useState("");
  const [pOSData, setPOSData] = useState([]);
  const [selectedPOS, setSelectedPOS] = useState(null);
  const [isAddCustomerOpen, setIsAddCustomerOpen] = useState(false);
  const [receiptTemplate, setReceiptTemplate] = useState("");
  const [isTemplateLoading, setIsTemplateLoading] = useState(true);
  const invoiceRef = useRef();
  const navigate = useNavigate();
  const barcodeInputRef = useRef(null);
  const [scannedBarcode, setScannedBarcode] = useState("");
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const [orderNo, setOrderNo] = useState("AUTO-GEN");
  const MySwal = withReactContent(Swal);
  const [showAdjustDiscount, setShowAdjustDiscount] = useState(false);
  const [currentBillData, setCurrentBillData] = useState(null);
  const [isSplitBill, setIsSplitBill] = useState(false);
  const [receiptFooter, setReceiptFooter] = useState("");
  // Previous Orders
  const [previousOrders, setPreviousOrders] = useState([]);
  const [loadingPreviousOrders, setLoadingPreviousOrders] = useState(false);
  useEffect(() => {
    barcodeInputRef.current?.focus();
  }, [selectedProducts]);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      setSelectedUserId(userData.UserId);
    } else {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    if (userDataSession?.UserId) {
      Axios.get(
        `${API_BASE_URL}${GET_STORE}?OrgId=${userDataSession?.OrgId}&UserId=${userDataSession.UserId}`,
      ).then((res) => {
        if (res.data.Status && res.data.ResultData.length > 0) {
          const first = res.data.ResultData[0];
          setSelectedStoreId(first.Id);
          setSelectedStoreName(first.Name);
          setStoreAddress(first?.Address);
          setOrgGST(first?.GSTIN);
        }
      });
    }
  }, [userDataSession?.UserId]);

  useEffect(() => {
    if (userDataSession?.OrgId && selectedStoreId) {
      Axios.post(`${API_BASE_URL}UnitInventory/getUnitProducts`, {
        OrgId: userDataSession.OrgId,
        ProductId: 0,
        StoreId: selectedStoreId,
      }).then((res) => {
        if (res.data.Status) setUnitProducts(res.data.ResultData || []);
      });
    }
  }, [selectedStoreId, userDataSession?.OrgId, isPlacingOrder]);

  useEffect(() => {
    if (userDataSession?.OrgId && selectedStoreId) {
      Axios.get(
        `${API_BASE_URL}settings/GetDiscounts/${userDataSession.OrgId}/${selectedStoreId}/1`,
      ).then((res) => {
        if (res.data.Status) {
          const opts = res.data.ResultData.map((d) => ({
            value: d.Id,
            label: d.IsFixed ? `Fixed ₹${d.Value}` : `${d.Value}% Off`,
            isFixed: d.IsFixed,
            amount: d.Value,
          }));
          setDiscounts([{ value: null, label: "No Discount" }, ...opts]);
        }
      });
    }
  }, [selectedStoreId, userDataSession?.OrgId]);

  useEffect(() => {
    if (userDataSession?.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_CUSTOMERS}?OrgId=${userDataSession.OrgId}&CustomerId=0`,
      ).then((res) => {
        if (res.data.Status) setCustomersDDL(res.data.ResultData);
      });
      Axios.get(
        `${API_BASE_URL}${GET_PAYMENTS_TYPES}?OrgId=${userDataSession.OrgId}`,
      ).then((res) => {
        if (res.data.Status) {
          setPaymentTypes(res.data.ResultData);
          const def = res.data.ResultData.find((pt) => pt.IsDefault);
          if (def) setSelectedPaymentType(def.Id);
        }
      });
      Axios.get(
        `${API_BASE_URL}${GET_TAXES_DATA}?OrgId=${userDataSession.OrgId}`,
      ).then((res) => {
        if (res.data.Status) {
          const taxList = res.data.ResultData.map((t) => ({
            value: t.Id,
            rate: t.TaxRate,
            sgst: t.SGSTRate,
            cgst: t.CGSTRate,
            isDefault: t.IsDefault,
          }));
          setTaxesData(taxList);
          const defTax = taxList.find((t) => t.isDefault) ||
            taxList.find((t) => t.rate === 0) || {
              value: 0,
              rate: 0,
              sgst: 0,
              cgst: 0,
            };
          setDefaultTax(defTax);
        }
      });
      Axios.get(
        `${API_BASE_URL}${GET_POS_TERMINALS}?OrgId=${userDataSession.OrgId}`,
      ).then((res) => {
        if (res.data.Status && res.data.ResultData.length > 0) {
          setPOSData(res.data.ResultData);
          setSelectedPOS(res.data.ResultData[0].Id);
        }
      });
      Axios.get(
        `${API_BASE_URL}${GET_STAFF}?OrgId=${userDataSession.OrgId}`,
      ).then((res) => {
        if (res.data.Status) setUsersList(res.data.ResultData || []);
      });
    }
  }, [userDataSession?.OrgId]);

  useEffect(() => {
    if (!userDataSession?.OrgId || !selectedStoreId) return;

    setLoadingPreviousOrders(true);

    const today = new Date();
    const todayStr = today.toISOString().split("T")[0]; // YYYY-MM-DD

    Axios.get(`${API_BASE_URL}${GET_ORDERS}`, {
      params: {
        OrgId: userDataSession.OrgId,
        StoreId: selectedStoreId,
        PosId: 0,
        OrderNo: "NULL",
        STdt: todayStr,
        enddt: todayStr,
      },
    })
      .then((response) => {
        if (response.data?.Status && Array.isArray(response.data.ResultData)) {
          const recentOrders = response.data.ResultData.sort(
            (a, b) =>
              new Date(
                b.OrderDate.split(" ")[0].split("/").reverse().join("-"),
              ) -
              new Date(
                a.OrderDate.split(" ")[0].split("/").reverse().join("-"),
              ),
          ).slice(0, 5);

          setPreviousOrders(recentOrders);
        } else {
          setPreviousOrders([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching previous orders:", error);
        setPreviousOrders([]);
      })
      .finally(() => setLoadingPreviousOrders(false));
  }, [userDataSession?.OrgId, selectedStoreId, isPlacingOrder]);

  useEffect(() => {
    const loadTemplate = async () => {
      try {
        const orgId = userDataSession?.OrgId;
        if (!orgId) return;

        const res = await Axios.get(
          `${API_BASE_URL}Product/get-template?OrgId=${orgId}`,
        );

        if (res.data.success) {
          setReceiptTemplate(res.data.html);
          setReceiptFooter(res.data.ReceiptFooter || "");
        } else {
          setReceiptTemplate(res.data); // fallback if old format
        }
      } catch (err) {
        console.error("Failed to load receipt template", err);
        setReceiptTemplate(
          `<div style="text-align:center; padding:40px;">Receipt</div>`,
        );
        setReceiptFooter("");
      } finally {
        setIsTemplateLoading(false);
      }
    };

    if (userDataSession?.OrgId) {
      loadTemplate();
    }
  }, [userDataSession?.OrgId]);
  const refreshCustomers = () => {
    Axios.get(
      `${API_BASE_URL}${GET_CUSTOMERS}?OrgId=${userDataSession.OrgId}&CustomerId=0`,
    ).then((res) => {
      if (res.data.Status) setCustomersDDL(res.data.ResultData || []);
    });
  };

  const handleBarcodeInput = (e) => {
    if (e.key === "Enter" && scannedBarcode.trim()) {
      const product = unitProducts.find(
        (p) => p.UnitBarcode === scannedBarcode.trim(),
      );
      if (product) handleAddToCart(product);
      else MySwal.fire("Not Found", `Barcode: ${scannedBarcode}`, "warning");
      setScannedBarcode("");
      barcodeInputRef.current?.focus();
    }
  };

  const prevOrderColumns = [
    {
      title: "S.No",
      render: (_, __, index) => index + 1,
      width: 70,
    },
    {
      title: "Order No",
      dataIndex: "OrderNo",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Date",
      dataIndex: "OrderDate",
    },
    {
      title: "Customer",
      dataIndex: "CustomerName",
      render: (text) => text || "Walk-in",
    },
    {
      title: "Total",
      dataIndex: "Total",
      render: (amount) => (
        <strong>₹{parseFloat(amount || 0).toLocaleString("en-IN")}</strong>
      ),
      align: "right",
    },
  ];
  const handleAddToCart = (unit) => {
    if (selectedProducts.find((p) => p.UnitId === unit.UnitId)) {
      MySwal.fire("Already Added", "This Product is in cart", "info");
      return;
    }
    setSelectedProducts((prev) => [
      ...prev,
      {
        UnitId: unit.UnitId,
        ProductId: unit.ProductId,
        ProductTitle: unit.ProductTitle,
        ProductName: unit.ProductName,
        UnitBarcode: unit.UnitBarcode,
        UnitPrice: unit.UnitPrice || 0,
        imageUrl: `${IMAGE_URL_IBIZ}ibiz/${userDataSession.OrgId}/Products/UnitInventory/${unit.UnitId}.jpg`,
        PriceInclusiveTax: unit.PriceInclusiveTax,
        TaxId: unit.TaxId,
      },
    ]);
  };

  const handleRemoveFromCart = (unitId) => {
    setSelectedProducts((prev) => prev.filter((p) => p.UnitId !== unitId));
  };

  const handleRemovePayment = (index) => {
    setPayments((prev) => prev.filter((_, i) => i !== index));
  };

  const handleViewImage = (imageUrl, title) => {
    setPreviewImageUrl(imageUrl);
    setPreviewTitle(title);
    setIsImageModalOpen(true);
  };

  const calculateAmounts = () => {
    let subtotal = 0;
    let totalTax = 0;

    selectedProducts.forEach((item) => {
      const gross = item.UnitPrice || 0;
      let base = gross;
      let taxAmt = 0;

      if (!isGstExempt) {
        const tax = taxesData.find((t) => t.value === item.TaxId) ||
          defaultTax || { rate: 0, sgst: 0, cgst: 0 };

        if (tax.rate > 0) {
          if (item.PriceInclusiveTax) {
            base = gross / (1 + tax.rate / 100);
            taxAmt = gross - base;
          } else {
            taxAmt = gross * (tax.rate / 100);
          }
        }
      }

      subtotal += base;
      totalTax += taxAmt;
    });

    let discount = 0;
    const selectedDisc = discounts.find(
      (d) => d.value === selectedDiscount?.value,
    );
    if (selectedDisc) {
      if (selectedDisc.isFixed) {
        discount = parseFloat(customDiscountAmount || selectedDisc.amount || 0);
      } else {
        discount = (selectedDisc.amount / 100) * subtotal;
      }
    }

    const grandTotal = subtotal + totalTax - discount;

    return {
      subtotal: subtotal.toFixed(2),
      discount: discount.toFixed(2),
      totalTax: totalTax.toFixed(2),
      grandTotal: grandTotal.toFixed(2),
    };
  };
  const amounts = calculateAmounts();
  const totalPaid = payments.reduce((s, p) => s + p.PaidAmount, 0);
  const remaining = (parseFloat(amounts.grandTotal) - totalPaid).toFixed(2);

  useEffect(() => {
    if (isSplitBill) {
      return;
    }
    if (
      !isSplitBill &&
      selectedPaymentType &&
      parseFloat(amounts.grandTotal) > 0
    ) {
      setPayments([
        {
          PaymentTypeId: selectedPaymentType,
          PaidAmount: parseFloat(amounts.grandTotal),
        },
      ]);
    }
  }, [isSplitBill, selectedPaymentType, amounts.grandTotal]); // Removed unnecessary dependencies

  useEffect(() => {
    if (isSplitBill && parseFloat(remaining) > 0) {
      setCurrentPaymentAmount(remaining);
    } else if (!isSplitBill) {
      setCurrentPaymentAmount("");
    }
  }, [isSplitBill, remaining]);
  const resetFormAfterOrder = () => {
    setSelectedProducts([]);
    setPayments([]);
    setSelectedDiscount(null);
    setCustomDiscountAmount("");
    setCurrentPaymentAmount("");
    setScannedBarcode("");
    setSelectedCusId(null);
    setOrderNo("AUTO-GEN");
  };

  const handleAddPayment = () => {
    const amt = parseFloat(currentPaymentAmount || 0);

    if (!selectedPaymentType || amt <= 0) {
      MySwal.fire(
        "Invalid",
        "Please select payment type and enter valid amount",
        "error",
      );
      return;
    }

    if (amt > parseFloat(remaining)) {
      MySwal.fire("Invalid", "Amount cannot be more than remaining", "error");
      return;
    }

    setPayments((prev) => {
      const existingIndex = prev.findIndex(
        (p) => p.PaymentTypeId === selectedPaymentType,
      );

      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex].PaidAmount += amt;
        return updated;
      } else {
        return [
          ...prev,
          { PaymentTypeId: selectedPaymentType, PaidAmount: amt },
        ];
      }
    });

    setCurrentPaymentAmount("");

    setCurrentPaymentAmount("");
  };

  const handlePrint = useReactToPrint({ content: () => invoiceRef.current });

  const getRenderedReceipt = (customOrderNo, adjustedItems = null) => {
    if (!receiptTemplate) return "<h3>Template not loaded</h3>";

    const username =
      usersList.find((u) => u.Id === selectedUserId)?.Name ||
      userDataSession?.UserName ||
      "Cashier";

    const terminalname =
      pOSData.find((pos) => pos.Id === selectedPOS)?.Name || "Counter";

    const customer = customersDDL.find((c) => c.Id === selectedCusId) || {
      Name: "Walk-in",
      Mobile: "",
      Email: "",
    };

    const itemsToPrint = adjustedItems || selectedProducts;

    const adjustedSubtotal = itemsToPrint.reduce((sum, item) => {
      return sum + parseFloat(item.finalPrice || item.UnitPrice || 0);
    }, 0);

    const data = {
      orgname:
        userDataSession?.BusinessName || userDataSession?.OrgName || " Store",
      storename: "",
      address: (storeAddress || userDataSession?.Address || "").replace(
        /\n/g,
        "<br>",
      ),
      gstin: orgGST ? `GSTIN: ${orgGST}` : "",
      orgimage: "",
      receipttype: "RECEIPT",
      orderno: customOrderNo,
      order_no: orderNo,
      orderdate: new Date().toLocaleDateString("en-IN"),
      ordertime: new Date().toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
      }),
      customer: customer.Name,
      customermobile: customer.Mobile || "",
      customeremail: customer.Email || "",
      salesperson: username,
      staffname: username,
      terminalname: terminalname,
      totalitems: itemsToPrint.length,
      "T&C": receiptFooter || "",
      "t&c": receiptFooter || "",
      tc: receiptFooter || "",

      items: itemsToPrint
        .map(
          (item, i) => `
      <tr class="service">
        <td class="item"><p class="itemtext">${i + 1}. ${item.ProductName}</p></td>
        <td class="qty"><p>1</p></td>
        <td class="rate"><p>₹${parseFloat(item.finalPrice || item.UnitPrice || 0).toFixed(2)}</p></td>
        <td class="value"><p>₹${parseFloat(item.finalPrice || item.UnitPrice || 0).toFixed(2)}</p></td>
      </tr>
    `,
        )
        .join(""),

      subtotal: `₹${adjustedSubtotal.toFixed(2)}`,
      sgst:
        amounts.totalTax > 0
          ? `₹${(parseFloat(amounts.totalTax) / 2).toFixed(2)}`
          : "",
      cgst:
        amounts.totalTax > 0
          ? `₹${(parseFloat(amounts.totalTax) / 2).toFixed(2)}`
          : "",
      discount: isFixedDiscount ? "0" : amounts?.discount || 0,
      total: `₹${amounts.grandTotal}`,
      payments: payments
        .map((p, i) => {
          const type =
            paymentTypes.find((pt) => pt.Id === p.PaymentTypeId)?.Name ||
            "CASH";
          return `<p>${i + 1}. ${type} ₹${p.PaidAmount.toFixed(2)}</p>`;
        })
        .join(""),
      paymentmode: payments
        .map((p) => {
          const type =
            paymentTypes.find((pt) => pt.Id === p.PaymentTypeId)?.Name ||
            "CASH";
          return `<p> ${type} </p>`;
        })
        .join(""),
      dinetype: "",
    };

    const conditions = {
      displayorgimage: data.orgimage ? "block" : "none",
      displayorgname: data.orgname ? "block" : "none",
      displaysgst: data.sgst ? "table-row" : "none",
      displaycgst: data.cgst ? "table-row" : "none",
      displaydiscount: "none",
      displaysalesperson:
        data.salesperson && data.salesperson !== "-" ? "table-row" : "none",
      displaycustomer: customer.Name !== "Walk-in " ? "block" : "none",
      displaycustomername: customer.Name !== "Walk-in" ? "table-row" : "none",
      displaycustomermobile: customer.Mobile ? "table-row" : "none",
      displaycustomeremail: customer.Email ? "table-row" : "none",
      displaypayments: payments.length > 0 ? "table-row" : "none",
    };

    let html = receiptTemplate;

    Object.entries(data).forEach(([key, value]) => {
      const placeholder = `##${key}##`;
      const safeValue = (value || "").toString().replace(/&/g, "&amp;");
      // .replace(/\n/g, "<br>");

      html = html.replace(
        new RegExp(placeholder.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"),
        safeValue,
      );
    });

    Object.entries(conditions).forEach(([key, value]) => {
      html = html.replace(new RegExp(`\\{\\{${key}\\}\\}`, "g"), value);
    });

    return html;
  };

  const handleSubmit = () => {
    if (selectedProducts.length === 0) {
      MySwal.fire("Error", "Add products ", "error");
      return;
    }
    let finalPayments = [...payments];

    if (finalPayments.length === 0 && !isSplitBill) {
      const defaultPaymentType =
        paymentTypes.find((pt) => pt.IsDefault) || paymentTypes[0];

      if (defaultPaymentType) {
        finalPayments = [
          {
            PaymentTypeId: defaultPaymentType.Id,
            PaidAmount: parseFloat(amounts.grandTotal),
          },
        ];
      }
    }
    let totalCGST = 0;
    let totalSGST = 0;

    const orderDetailsPayload = selectedProducts.map((prod) => {
      const lineGross = prod.UnitPrice || 0;
      let sgst = 0;
      let cgst = 0;
      let lineSubExcl = lineGross;

      const tax = taxesData.find((t) => t.value === prod.TaxId) ||
        defaultTax || { rate: 0, sgst: 0, cgst: 0 };

      if (!isGstExempt) {
        if (tax.rate > 0) {
          const totalRate = tax.rate;
          if (prod.PriceInclusiveTax) {
            lineSubExcl = lineGross / (1 + totalRate / 100);
            sgst = lineSubExcl * (tax.sgst / 100 || totalRate / 200);
            cgst = lineSubExcl * (tax.cgst / 100 || totalRate / 200);
          } else {
            sgst = lineGross * (tax.sgst / 100 || totalRate / 200);
            cgst = lineGross * (tax.cgst / 100 || totalRate / 200);
          }
        }
      }

      totalCGST += cgst;
      totalSGST += sgst;

      return {
        ProductId: prod.ProductId,
        Quantity: 1,
        UnitPrice: prod.UnitPrice,
        Discount: 0,
        SGST: isGstExempt ? 0 : parseFloat(sgst.toFixed(2)),
        CGST: isGstExempt ? 0 : parseFloat(cgst.toFixed(2)),
        IGST: 0,
        Total: isGstExempt
          ? lineGross
          : prod.PriceInclusiveTax
            ? lineGross
            : lineSubExcl + sgst + cgst,
        Status: 1,
        RefundQuantity: 0,
        IsActive: 1,
        VendorId: 0,
        IsComplement: 0,
        CGSTrate: isGstExempt ? 0 : tax.cgst || 0,
        SGSTrate: isGstExempt ? 0 : tax.sgst || 0,
        IGSTrate: 0,
        NoOfBags: 0,
        Comments: "",
        ItemWeight: 1,
        ItemPackingWeight: 0,
        BilledBarCode: prod.UnitBarcode,
      };
    });

    const payload = {
      orgid: userDataSession?.OrgId,
      userid: userDataSession?.UserId,
      OrgType: userDataSession?.OrgType || 1,
      BillNo: null,
      Order: {
        StoreId: selectedStoreId,
        PosId: selectedPOS || 0,
        OrderType: 1,
        Total: parseFloat(amounts.grandTotal),
        Discounts: parseFloat(amounts.discount || 0),
        SGST: isGstExempt ? 0 : parseFloat(totalSGST.toFixed(2)),
        CGST: isGstExempt ? 0 : parseFloat(totalCGST.toFixed(2)),
        IGST: 0,
        Status: 1,
        IsActive: 1,
        Orderdate: new Date().toISOString(),
        DiscountId: selectedDiscount?.value || 0,
        DiningId: 0,
        ReturnFromOrdId: 0,
        CustomerId: selectedCusId || 0,
        PriceListId: 0,
        TransportMode: "NULL",
        TransportvehicleNumber: "NULL",
        AdditionalCharges: 0,
        AdditionalRoundOffAmount: 0,
        IsAcknowledge: 0,
        TransportAmount: 0,
        InvoiceNo: "NULL",
        EmpId: selectedUserId || userDataSession.UserId,
      },
      OrderDetails: orderDetailsPayload,
      OrderAdditionalDetails: selectedProducts.map((prod) => ({
        ProductId: prod.ProductId,
        MakingCharges: 0,
        OtherCharges: 0,
        MetalRateId: 0,
      })),
      // OrderPayments: payments.map((p) => ({
      //   PaymentTypeId: p.PaymentTypeId,
      //   PaidAmount: p.PaidAmount,
      //   CardNo: "",
      //   MobileNo: "",
      // })),

      OrderPayments: finalPayments.map((p) => ({
        PaymentTypeId: p.PaymentTypeId,
        PaidAmount: p.PaidAmount,
        CardNo: "",
        MobileNo: "",
      })),
      StockHistory: selectedProducts.map((prod) => ({
        ProductId: prod.ProductId,
        StoreId: selectedStoreId,
        StockEffectTypeId: 0,
        StockAdjusted: -1,
        TransactionId: 0,
        TransfarStockId: 0,
        StockAdjustId: 0,
        IsActive: 1,
        SupplierId: 0,
      })),
      StoreProducts: selectedProducts.map((prod) => ({
        ProductId: prod.ProductId,
        StoreId: selectedStoreId,
        StockAdjusted: -1,
      })),
    };

    setIsPlacingOrder(true);

    const endpoint = isGstExempt
      ? `${API_BASE_URL}Billing/SaveOrdersV2`
      : `${API_BASE_URL}${INSERT_ORDERS}`;

    Axios.post(endpoint, payload)

      .then((response) => {
        const orderData = response.data?.[0];
        if (orderData && orderData.OrderId >= 1) {
          const realOrderNo = orderData.OrderNo || "AUTO-GEN";
          setOrderNo(realOrderNo);

          const billDataForAdjustment = {
            billedAmount: parseFloat(amounts.grandTotal),
            discountAmount: parseFloat(amounts.discount) || 0,
            items: selectedProducts.map((prod) => ({
              UnitId: prod.UnitId,
              ProductName: prod.ProductName,
              UnitPrice: parseFloat(prod.UnitPrice) || 0,
            })),
          };
          if (!isFixedDiscount) {
            const finalHtml = getRenderedReceipt(realOrderNo);
            if (invoiceRef.current) {
              invoiceRef.current.innerHTML = finalHtml;
            }
            setTimeout(() => {
              handlePrint();
            }, 300);
            resetFormAfterOrder();
          } else {
            MySwal.fire({
              title: "Order Placed Successfully!",
              text: "Do you want to adjust the discount now?",
              icon: "success",
              showCancelButton: true,
              confirmButtonText: "Yes, Adjust Discount",
              cancelButtonText: "No, Skip",
            }).then((result) => {
              if (result.isConfirmed) {
                setCurrentBillData(billDataForAdjustment);
                setShowAdjustDiscount(true);
              } else {
                const finalHtml = getRenderedReceipt(realOrderNo);
                if (invoiceRef.current)
                  invoiceRef.current.innerHTML = finalHtml;
                setTimeout(() => handlePrint(), 300);
                resetFormAfterOrder();
              }
            });
          }
        } else {
          MySwal.fire("Error", "Failed to place order.", "error");
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        MySwal.fire("Error", "An error occurred.", "error");
      })
      .finally(() => setIsPlacingOrder(false));
  };

  const columns = [
    { title: "S.No", render: (_, __, index) => index + 1, width: 70 },
    {
      title: "Item",
      render: (record) => (
        <>
          <div className="fw-semibold">{record.ProductName}</div>
          <small className="text-muted">Barcode: {record.UnitBarcode}</small>
        </>
      ),
    },
    { title: "Qty", render: () => <span>1</span>, align: "center", width: 100 },
    {
      title: "Amount",
      render: (record) => (
        <strong>₹{parseFloat(record.UnitPrice).toLocaleString("en-IN")}</strong>
      ),
      align: "right",
      width: 130,
    },
    {
      title: "Image",
      render: (record) => (
        <img
          src={record.imageUrl}
          alt={record.ProductTitle}
          className="rounded border shadow-sm"
          style={{
            width: "60px",
            height: "60px",
            objectFit: "cover",
            cursor: "pointer",
          }}
          onClick={() => handleViewImage(record.imageUrl, record.ProductTitle)}
        />
      ),
      align: "center",
      width: 100,
    },
    {
      title: "Action",
      render: (record) => (
        <button
          className="btn btn-sm btn-outline-danger"
          onClick={() => handleRemoveFromCart(record.UnitId)}
        >
          <Trash2 size={18} />
        </button>
      ),
      align: "center",
      width: 100,
    },
  ];

  const selectedDisc = discounts.find(
    (d) => d.value === selectedDiscount?.value,
  );
  const isFixedDiscount = selectedDisc?.isFixed || false;

  return (
    <>
      {isPlacingOrder && <SpinLoader />}
      <div className="page-wrapper pos-pg-wrapper ms-0">
        <div className="conten pos-design p-0 bg-white">
          <div className="p-3 border-bottom d-flex align-items-center gap-4">
            <h5 className="mb-0 flex-shrink-0">
              Store:{" "}
              <strong>{userDataSession?.StoreName || selectedStoreName}</strong>
            </h5>

            <div className="flex-grow-1 ps-3">
              <div className="position-relative" style={{ maxWidth: "300px" }}>
                <i className="fa-solid fa-barcode position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" />
                <input
                  type="text"
                  className="form-control ps-5"
                  placeholder="Scan Barcode & Press Enter"
                  ref={barcodeInputRef}
                  value={scannedBarcode}
                  onChange={(e) => setScannedBarcode(e.target.value)}
                  onKeyDown={handleBarcodeInput}
                />
              </div>
            </div>

            {/* Right: View Orders Button */}
            <div className="flex-shrink-0">
              <Link to="/sales-list" className="btn btn-secondary">
                <i className="fas fa-cart-shopping me-2"></i>
                View Orders
              </Link>
            </div>
          </div>
          <div className="row g-0">
            <div
              className="col-lg-8 p-3 d-flex flex-column"
              style={{ height: "calc(100vh - 85px)" }}
            >
              <div
                className="flex-grow-1 overflow-auto"
                style={{ minHeight: "0" }}
              >
                {/* Current Cart Section */}
                <div className="mb-5">
                  {/* <h5 className="mb-3">Current Cart</h5> */}

                  {selectedProducts.length === 0 ? (
                    <div className="text-center py-5 border rounded bg-light">
                      <i className="fa-solid fa-barcode fa-5x text-muted mb-4"></i>
                      <h4 className="text-muted">
                        Scan a product barcode to begin
                      </h4>
                    </div>
                  ) : (
                    <div className="card table-list-card">
                      <div className="card-body p-0">
                        <Table
                          columns={columns}
                          dataSource={selectedProducts}
                          rowKey="UnitId"
                          pagination={false}
                          scroll={{ y: 420 }} // Internal table scroll for better performance
                        />
                      </div>
                    </div>
                  )}
                </div>

                {/* Recent Orders Section */}
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Recent Orders</h5>
                    <Link
                      to="/sales-list"
                      className="d-none btn btn-sm btn-outline-secondary"
                    >
                      View All Orders
                    </Link>
                  </div>
                  <hr />
                  <div className="card table-list-card d-none">
                    <div className="card-body p-0">
                      {loadingPreviousOrders ? (
                        <div className="text-center py-5">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      ) : previousOrders.length === 0 ? (
                        <div className="text-center py-5 text-muted border rounded bg-light">
                          No orders found today
                        </div>
                      ) : (
                        <Table
                          columns={prevOrderColumns}
                          dataSource={previousOrders}
                          rowKey="Id"
                          pagination={false}
                          scroll={{ y: 280 }}
                          size="small"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Right Sidebar */}
            <div className="col-lg-4 p-4 border-start">
              <div className="sticky-top" style={{ top: "10px" }}>
                {/* POS & User */}
                <div className="row g-2 mb-3 d-none">
                  <div className="col-6">
                    <label className="form-label">POS Terminal</label>
                    <Select
                      options={pOSData.map((pos) => ({
                        value: pos.Id,
                        label: pos.Name,
                      }))}
                      value={
                        pOSData.find((p) => p.Id === selectedPOS)
                          ? {
                              value: selectedPOS,
                              label: pOSData.find((p) => p.Id === selectedPOS)
                                ?.Name,
                            }
                          : null
                      }
                      onChange={(opt) => setSelectedPOS(opt?.value || null)}
                      placeholder="Select POS"
                    />
                  </div>
                  <div className="col-6">
                    <label className="form-label">Staff</label>
                    <Select
                      options={usersList.map((u) => ({
                        value: u.Id,
                        label: u.Name,
                      }))}
                      value={
                        usersList.find((u) => u.Id === selectedUserId)
                          ? {
                              value: selectedUserId,
                              label: usersList.find(
                                (u) => u.Id === selectedUserId,
                              )?.Name,
                            }
                          : null
                      }
                      onChange={(opt) => setSelectedUserId(opt?.value || null)}
                      placeholder="Select Staff"
                    />
                  </div>
                </div>
                {/* Customer */}
                <div className="d-flex align-items-center mb-3">
                  <div className="flex-grow-1 me-2">
                    <label className="form-label mb-1">Customer</label>
                    <Select
                      options={customersDDL.map((c) => ({
                        value: c.Id,
                        label: c.Name,
                      }))}
                      placeholder="Select Customer"
                      value={
                        selectedCusId
                          ? customersDDL.find((c) => c.Id === selectedCusId)
                            ? {
                                value: selectedCusId,
                                label: customersDDL.find(
                                  (c) => c.Id === selectedCusId,
                                ).Name,
                              }
                            : null
                          : null
                      }
                      onChange={(opt) => {
                        setSelectedCusId(opt?.value || null); // This will properly set to null when cleared
                      }}
                      isClearable={true} // ← Important: Allows clearing with × button
                      isSearchable={true}
                    />
                  </div>
                  <button
                    className="btn btn-primary mt-4"
                    onClick={() => setIsAddCustomerOpen(true)}
                  >
                    <i className="fa-solid fa-user-plus"></i>
                  </button>
                </div>
                {/* Discount */}
                {/* Improved Discount Section - Grouped Dropdown + Input */}
                {/* Discount Section */}
                <div className="row g-2 mb-3">
                  <div className="col-12">
                    <label className="form-label">Discount</label>

                    <div className="d-flex gap-2">
                      {/* Amount Input */}
                      <div style={{ flex: "1" }}>
                        <input
                          type="number"
                          className="form-control"
                          value={customDiscountAmount}
                          onChange={(e) =>
                            setCustomDiscountAmount(e.target.value)
                          }
                          placeholder="0"
                          onWheel={(e) => e.target.blur()}
                          disabled={
                            !selectedDiscount?.value || !isFixedDiscount
                          }
                        />
                      </div>

                      {/* Discount Type Dropdown */}
                      <div style={{ minWidth: "220px" }}>
                        <Select
                          options={discounts}
                          value={
                            discounts.find(
                              (d) => d.value === selectedDiscount?.value,
                            ) || discounts[0]
                          }
                          onChange={(opt) => {
                            setSelectedDiscount(opt?.value ? opt : null);
                            setCustomDiscountAmount(""); // Reset amount when discount type changes
                          }}
                          placeholder="No Discount"
                          className="basic-single"
                          classNamePrefix="select"
                        />
                      </div>
                    </div>

                    {selectedDiscount?.value && (
                      <small className="text-muted mt-1 d-block">
                        {isFixedDiscount
                          ? "Enter fixed discount amount (₹)"
                          : "Percentage discount applied on subtotal"}
                      </small>
                    )}
                  </div>

                  {/* Split Bill Checkbox - Moved here for better layout */}
                  <div className="col-12 mt-2">
                    <div className="form-check ">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="splitBill"
                        checked={isSplitBill}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setIsSplitBill(checked);

                          if (checked) {
                            // Split Bill ON
                            setPayments([]);
                            setCurrentPaymentAmount(amounts.grandTotal); // Pre-fill full amount
                          } else {
                            // Split Bill OFF
                            setCurrentPaymentAmount("");
                          }
                        }}
                      />
                      <label
                        className="form-check-label fw-semibold"
                        htmlFor="splitBill"
                      >
                        Split Bill (Multiple Payment Modes)
                      </label>
                    </div>
                  </div>
                </div>
                {/* Payment */}

                {/* Totals */}

                {/* Payment Section - Always Visible */}
                <div className="mb-4">
                  <div className="row g-3 align-items-end">
                    {/* Payment Type Dropdown */}
                    <div className="col-md-5">
                      <label className="form-label">Payment Type</label>
                      <Select
                        options={paymentTypes.map((pt) => ({
                          value: pt.Id,
                          label: pt.Name,
                        }))}
                        value={
                          paymentTypes.find(
                            (pt) => pt.Id === selectedPaymentType,
                          )
                            ? {
                                value: selectedPaymentType,
                                label: paymentTypes.find(
                                  (pt) => pt.Id === selectedPaymentType,
                                )?.Name,
                              }
                            : null
                        }
                        onChange={(opt) =>
                          setSelectedPaymentType(opt?.value || null)
                        }
                        placeholder="Select Payment Type"
                        isClearable={true}
                      />
                    </div>

                    <div className="col-md-5">
                      <label className="form-label">Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        value={currentPaymentAmount}
                        onChange={(e) =>
                          setCurrentPaymentAmount(e.target.value)
                        } // ← Fixed
                        placeholder="Enter amount"
                        onWheel={(e) => e.target.blur()}
                        disabled={!isSplitBill}
                      />
                    </div>

                    {/* Add Button */}
                    <div className="col-md-2">
                      <label className="form-label d-none d-md-block">
                        &nbsp;
                      </label>
                      <button
                        className="btn btn-primary w-100"
                        onClick={handleAddPayment}
                        style={{ height: "38px" }}
                        disabled={!isSplitBill}
                      >
                        <i className="fas fa-plus me-1"></i>
                      </button>
                    </div>
                  </div>

                  {isSplitBill && payments.length > 0 && (
                    <div className="mt-3">
                      <label className="form-label">Added Payments</label>
                      <div className="d-flex flex-wrap gap-2">
                        {payments.map((p, i) => {
                          const typeName =
                            paymentTypes.find((pt) => pt.Id === p.PaymentTypeId)
                              ?.Name || "Unknown";
                          return (
                            <div
                              key={i}
                              className="badge bg-primary d-flex align-items-center gap-2 px-3 py-2"
                              style={{ fontSize: "0.95rem" }}
                            >
                              {typeName} ₹{p.PaidAmount.toFixed(2)}
                              <button
                                className="btn btn-sm text-white p-0 ms-1"
                                onClick={() => handleRemovePayment(i)}
                                style={{ fontSize: "1.1rem", lineHeight: "1" }}
                              >
                                ×
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
                <div className="bg-white p-3 rounded mb-4 border">
                  <div className="d-flex justify-content-between mb-2">
                    <span>Subtotal</span>
                    <strong>₹{amounts.subtotal}</strong>
                  </div>

                  {parseFloat(amounts.discount) > 0 && (
                    <div className="d-flex justify-content-between mb-2 text-danger">
                      <span>Discount</span>
                      <strong>-₹{amounts.discount}</strong>
                    </div>
                  )}

                  <div className="d-flex justify-content-between mb-2">
                    <span>Tax</span>
                    <strong>₹{amounts.totalTax}</strong>
                  </div>

                  <hr />

                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 text-success">Total</h5>
                    <h4 className="mb-0 text-success">₹{amounts.grandTotal}</h4>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-success "
                    disabled={
                      selectedProducts.length === 0 ||
                      isTemplateLoading ||
                      (isSplitBill && parseFloat(remaining) > 0)
                    }
                    onClick={handleSubmit}
                  >
                    Place Order
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Image Modal */}
        <div
          className={`modal fade ${isImageModalOpen ? "show d-block" : ""}`}
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={() => setIsImageModalOpen(false)}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h5 className="modal-title">
                  {previewTitle || "Product Image"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setIsImageModalOpen(false)}
                />
              </div>
              <div className="modal-body text-center p-4 bg-light">
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "70vh" }}
                >
                  {previewImageUrl && (
                    <img
                      src={previewImageUrl}
                      alt={previewTitle}
                      className="img-fluid rounded shadow"
                      style={{
                        maxHeight: "70vh",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Invoice Modal */}
        {/* Hidden container for printing */}
        <div style={{ display: "none" }}>
          <div ref={invoiceRef}></div>
        </div>
        <AddCustomerModal
          isOpen={isAddCustomerOpen}
          onClose={() => setIsAddCustomerOpen(false)}
          onCustomerAdded={refreshCustomers}
        />
        <AdjustDiscount
          isOpen={showAdjustDiscount}
          onClose={() => setShowAdjustDiscount(false)}
          billData={currentBillData}
          onAdjustmentComplete={(adjustedItems) => {
            const finalHtml = getRenderedReceipt(orderNo, adjustedItems);
            if (invoiceRef.current) {
              invoiceRef.current.innerHTML = finalHtml;
            }
            setTimeout(() => {
              handlePrint();
            }, 300);

            resetFormAfterOrder();
          }}
        />
      </div>
    </>
  );
};

export default AddSaleNew;
